/* eslint-disable import/no-cycle */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@glu/theming';

import get from 'lodash/get';

import LocaleContext from '../../locale/LocaleContext';

import { getPaymentType } from '../../createPayment/CreatePayment.utils';
import { maxCharactersTemplate } from '../../gluValidation/utils';
import { lt } from '../../../utils/validations/gluValidations';

import Input from '../../gluValidation/Input';

import { PAYMENT_TYPES } from '../../../constants';

const styles = () => ({
  confirmation: {
    '& .help-block': {
      marginBottom: 0
    }
  },
  labelClass: {
    display: 'block'
  }
});

const useStyles = createUseStyles(styles);

const CustomRateConfirmationComponent = ({ data, formState, isTemplate, source }) => {
  const locale = useContext(LocaleContext);
  const classes = useStyles();

  const disabled = ['mtsContractNumberEditable'].every((x) => !data.wirePreferences[x]);

  const id = get(formState.currency, '0.id', get(formState, 'currency.id'));
  const fxRatesInstance = data.fxRates.find((x) => x.id === id);
  const usd = (fxRatesInstance && fxRatesInstance.currency === locale['common.usd']) || id === 1;
  const domestic =
    get(
      formState,
      'paymentType[0].type',
      getPaymentType(formState, data.paymentTypeOptions, { template: isTemplate })
    ) === PAYMENT_TYPES.WIRE.DOMESTIC;

  if (domestic || usd || !get(data, 'wirePreferences.mtsContractNumberDisplay')) {
    return null;
  }

  const exact = fxRatesInstance && parseFloat(source.exchangeRate) === fxRatesInstance.exchange;

  const inputProps = {
    id: 'customRateConfirmation',
    name: 'customRateConfirmation',
    label: `${locale['common.confirmation']} #`,
    labelClass: classes.labelClass,
    className: classes.confirmation,
    debounceInput: true,
    maxLength: 11,
    validators: [lt({ maxLength: 10, msg: maxCharactersTemplate(locale, 10) })],
    helpMsg: locale['create.payment.info.appliesToRateConfirm'],
    disabled: disabled || exact
  };

  return (
    <div className="col-xs-3">
      <Input {...inputProps} />
    </div>
  );
};

CustomRateConfirmationComponent.propTypes = {
  data: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  formState: PropTypes.shape({}).isRequired,
  source: PropTypes.shape({
    exchangeRate: PropTypes.any
  }).isRequired,
  isTemplate: PropTypes.bool.isRequired
};

export default CustomRateConfirmationComponent;
